// extracted by mini-css-extract-plugin
export default {"list":"DropdownList_list__TESal"};